import React from "react";

/**
 * SeasonalNote — a whispered one-line acknowledgment that appears on the
 * six turning-days of the year (solstices + equinoxes + the first
 * meteorological days of each season). Renders nothing on ordinary days.
 *
 * Kept intentionally quiet: small copper eyebrow line under the hero,
 * never a headline, never a modal.
 */
const NOTES = {
  // Astronomical turning points (approximate — same date every year in
  // recent decades; edited if we ever get complaints from the pedants).
  "03-20": { season: "spring", line: "First day of spring — the light lasts longer now." },
  "06-21": { season: "summer", line: "Solstice — the longest day. Let something in you slow." },
  "09-22": { season: "autumn", line: "First day of autumn — a softer light returns." },
  "12-21": { season: "winter", line: "Winter solstice — from here the days begin to lengthen." },
  // Meteorological handovers (the first of the month a season begins)
  "03-01": { season: "spring", line: "March opens — a hint of green returns." },
  "06-01": { season: "summer", line: "June opens — the mornings arrive warmer." },
  "09-01": { season: "autumn", line: "September opens — the light turns amber." },
  "12-01": { season: "winter", line: "December opens — softer inside, quieter out." },
  // New year
  "01-01": { season: "winter", line: "A new page. Nothing needs to change today — just noticed." },
};

export default function SeasonalNote({ testid = "seasonal-note", now }) {
  const d = now || new Date();
  const key = `${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const entry = NOTES[key];
  if (!entry) return null;

  return (
    <div
      className="relative mt-3 flex items-center gap-3 text-[11px] uppercase tracking-[0.32em]"
      data-testid={testid}
      style={{ animation: "reveal 700ms ease-out both", color: "hsl(var(--copper))" }}
    >
      <span aria-hidden className="w-6 h-px bg-[hsl(var(--copper))]/60" />
      <span className="normal-case tracking-normal text-[13.5px] italic font-display text-[hsl(var(--fg))]/80">
        {entry.line}
      </span>
    </div>
  );
}
